import type { TopicTimelineItem } from '@/mocks/topics';

interface TopicTimelineProps {
  items: TopicTimelineItem[];
}

export default function TopicTimeline({ items }: TopicTimelineProps) {
  return (
    <ol className="relative space-y-6 border-l border-background-300 pl-6">
      {items.map((item, index) => (
        <li key={item.time} className="relative">
          <span
            className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 ${
              index === items.length - 1 ? 'bg-primary-500' : 'bg-secondary-400'
            }`}
          />
          <time className="text-xs font-medium text-primary-600">{item.time}</time>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{item.text}</p>
        </li>
      ))}
    </ol>
  );
}